import type { Category } from "../Category.js";
import type { Locale } from "../Locale.js";
import { referencesPathMap } from "./referencesPathMap.js";

export function getReferencesInProductCategoryPath(category: Category, locale: Locale): string {
	return `${referencesPathMap[locale]}/${category.urlSlug}`;
}
